import React from 'react';
import { Card } from '@components/atoms/Card';
import { ProjectSelectionHeader } from './ProjectSelectionHeader';
import { ProjectSelectionHint } from './ProjectSelectionHint';
import { ProjectSelector } from './ProjectSelector';
import { ProjectOption } from '../types';

interface ProjectSelectionProps {
  selectedOrganizationName?: string;
  selectedOrganizationId?: string;
  projectOptions: ProjectOption[];
  selectedProjectId: string | null;
  onProjectChange: (value: any) => void;
}

export const ProjectSelection: React.FC<ProjectSelectionProps> = ({
  selectedOrganizationName,
  selectedOrganizationId,
  projectOptions,
  selectedProjectId,
  onProjectChange,
}) => {
  const hasSelectedOrganization = Boolean(selectedOrganizationName);
  const hasProjects = projectOptions.length > 0;

  return (
    <Card>
      <ProjectSelectionHeader
        selectedOrganizationName={selectedOrganizationName}
        hasSelectedOrganization={hasSelectedOrganization}
      />

      <ProjectSelectionHint
        hasSelectedOrganization={hasSelectedOrganization}
        hasProjects={hasProjects}
      />

      <ProjectSelector
        projectOptions={projectOptions}
        selectedProjectId={selectedProjectId}
        onChange={onProjectChange}
        hasSelectedOrganization={hasSelectedOrganization}
        organizationId={selectedOrganizationId}
      />
    </Card>
  );
};
